<template>
  <div>
    <div v-if="!this.groupRequests">
      <Loader />
    </div>
    <div v-if="this.groupRequests">
      <v-col cols="12" v-for="item in this.groupRequests" :key="item.id">
        <v-card class="mx-auto">
          <template slot="progress">
            <v-progress-linear
              color="deep-purple"
              height="10"
              indeterminate
            ></v-progress-linear>
          </template>

          <v-img
            v-if="item.images.length > 0"
            height="250"
            :src="item.images ? item.images[0] : ''"
          ></v-img>

          <v-img
            v-else
            height="250"
            :src="require('@/assets/logos/icon3.svg')"
          />

          <v-card-title> {{ item.itemName }}</v-card-title>

          <v-card-text>
            <v-row align="center" class="mx-0">
              <v-rating
                :value="4.5"
                color="amber"
                dense
                half-increments
                readonly
                size="14"
              ></v-rating>

              <div class="grey--text ms-4">4.5 (413)</div>
            </v-row>

            <!-- <v-row class="d-flex justify-space-around"> -->
            <div class="my-4 text-subtitle-1">
              {{ item.created_by }}
            </div>
            <!-- <div class="my-4 text-subtitle-1">
                {{ item.created_by }}
              </div> -->
            <!-- </v-row> -->
          </v-card-text>

          <v-divider class="mx-4"></v-divider>

          <v-card-title> R{{ item.dailyFee }} per day</v-card-title>

          <v-card-text class="my-4 text-subtitle-1">
            {{ item.description }}
          </v-card-text>

          <!-- <v-card-text>
            <v-chip-group
              v-model="selection"
              active-class="deep-purple accent-4 white--text"
              column
            >
              <v-chip>5:30PM</v-chip>

              <v-chip>7:30PM</v-chip>

              <v-chip>8:00PM</v-chip>

              <v-chip>9:00PM</v-chip>
            </v-chip-group>
          </v-card-text> -->

          <v-card-actions>
            <v-btn color="deep-purple lighten-2" text> Fulfill Request </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </div>
  </div>
</template>

<script>
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from 'firebase/firestore';
export default {
  name: 'StrappGroupItems',

  data() {
    return {
      groupRequests: [],
    };
  },

  components: {
    Loader: () => import('@/components/Loader.vue'),
  },

  async created() {
    const db = getFirestore();
    const q = query(
      collection(db, 'requests'),
      where('groupIds', 'array-contains', this.$route.params.name)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      console.log(doc.id, ' => ', doc.data());
    });

    this.groupRequests = querySnapshot.docs.map((doc) => {
      return { id: doc.id, ...doc.data() };
    });

    console.log(this.groupRequests);
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
